import classNames from 'classnames';

// Components
import Link from '../../ui/Link/Link';

// Hooks
import { useAppSelector } from '../../../store';

// Styles
import styles from './Seed.module.scss';

const Seed = ({ seedText, isSoon, releaseDateText, linkTo, isCompleted }) => {
  const activeSeed = useAppSelector(s => s.seeds.activeSeed);
  const isActive = activeSeed === seedText;

  const content = (
    <>
      <p
        className={classNames(styles.content, {
          [styles.isActive]: isActive,
        })}
      >
        {seedText}
      </p>
      {isSoon && <p className={classNames(styles.soon, { [styles.isActive]: isActive })}>(Soon)</p>}
      {isCompleted && (
        <p className={classNames(styles.soon, { [styles.isActive]: isActive })}>(Completed)</p>
      )}
      {releaseDateText && (
        <p className={classNames(styles.soon, { [styles.isActive]: isActive })}>
          ({releaseDateText})
        </p>
      )}
    </>
  );

  return (
    <li
      className={classNames(styles.wrapper, {
        [styles.isActive]: isActive,
      })}
    >
      {linkTo ? <Link to={linkTo}>{content}</Link> : content}
    </li>
  );
};

export default Seed;
